// import logo from './logo.svg';
import {
  Routes,
  Route,
  HashRouter
} from "react-router-dom";
import './App.css';
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Wine from "./pages/wine";
import TopWine from "./pages/TopWine";
import TableOfConents from "./pages/TableOfConents";
import Home from "./pages/home";
import NotFound from "./pages/NotFound";
import Definitions from "./pages/definitions";
import Credits from "./pages/credits";

function App() {
  return (
    <HashRouter>
      <Nav />
      <div className="App col-lg-12 mx-auto">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="wine" element={<Wine />} />
          <Route path="table-of-contents" element={<TableOfConents />} />
          <Route path="wine-top-picks" element={<TopWine/>} />
          <Route path="italiano" element={<Wine type='italiano' />} />
          <Route path="rosso" element={<Wine type='rosso' />} />
          <Route path="bianco" element={<Wine type='bianco' />} />
          <Route path="sparkling" element={<Wine type='sparkling' />} />
          <Route path="rose" element={<Wine type='rose' />} />
          <Route path="definitions" element={<Definitions/>} />
          <Route path="credits" element={<Credits/>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </HashRouter>
  );
}

export default App;
